import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

export const useSuggestedResponses = (bonusId: string) => {
	const http = useHttpClient();

	const { data = [], isLoading } = useQuery({
		queryKey: ['suggested-responses', bonusId],
		queryFn: async () => {
			const res = await http.get<{ result: string[] }>('/suggestions', {
				params: { bonus_id: bonusId },
			});

			return res.data.result;
		},
	});

	return {
		isLoading,
		suggestions: data,
	};
};
